<div class="square">
  <h3>Child Default Detection Component</h3>

  <app-life-cycle-list></app-life-cycle-list>

  <div class="counter-container">
    <app-counter
      title="Local Non Reactive Counter"
      [value]="nonReactiveCounter"
      (increase)="increaseNonReactiveCounter()"
      [style]="CounterStyle.LocalNonReactive"
    ></app-counter>

    <app-counter
      title="Local Reactive Counter Observable"
      [value]="reactiveCounter$ | async"
      (increase)="increaseReactiveCounter()"
      [style]="CounterStyle.LocalReactive"
    ></app-counter>

    <app-counter
      title="Shared Non Reactive Counter Observable"
      [value]="sharedNonReactiveCounter"
      (increase)="increaseNonReactiveSharedCounter()"
      [style]="CounterStyle.SharedNonReactive"
    ></app-counter>

    <app-counter
      title="Shared Reactive Counter Observable"
      [value]="sharedReactiveCounter$ | async"
      (increase)="increaseReactiveSharedCounter()"
      [style]="CounterStyle.SharedReactive"
    ></app-counter>
  </div>
</div>
